import React from 'react';

const ErrorModal = ({ 
    show, 
    onClose, 
    onRetry, 
    onBackToData, 
    title = "Error Loading Data", 
    message = "Something went wrong while loading data.",
    showRetryButton = true,
    showBackButton = true,
    retryButtonText = "Try Again",
    backButtonText = "Back to Data"
}) => {
    if (!show) return null;

    return (
        <div 
            className="modal-overlay" 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1050,
                backdropFilter: 'blur(2px)'
            }}
            onClick={onClose}
        >
            <div 
                className="modal-content"
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    padding: '40px',
                    maxWidth: '500px',
                    width: '90%',
                    textAlign: 'center',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                    animation: 'modalFadeIn 0.3s ease-out'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ marginBottom: '20px' }}>
                    <i 
                        className="fa fa-exclamation-triangle" 
                        style={{ 
                            fontSize: '48px', 
                            color: '#dc3545',
                            marginBottom: '15px'
                        }}
                    ></i>
                </div>
                
                <h4 
                    style={{ 
                        color: '#dc3545', 
                        marginBottom: '15px',
                        fontWeight: '600'
                    }}
                >
                    {title}
                </h4>
                
                <p 
                    style={{ 
                        color: '#6c757d', 
                        marginBottom: '30px',
                        fontSize: '14px',
                        lineHeight: '1.5'
                    }}
                >
                    {message}
                </p>
                
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                    {showRetryButton && (
                        <button 
                            className="btn btn-primary"
                            onClick={onRetry}
                            style={{
                                padding: '10px 20px',
                                fontSize: '14px',
                                fontWeight: '500'
                            }}
                        >
                            <i className="fa fa-refresh" style={{ marginRight: '8px' }}></i>
                            {retryButtonText}
                        </button>
                    )}
                    
                    {showBackButton && (
                        <button 
                            className="btn btn-default"
                            onClick={onBackToData}
                            style={{
                                padding: '10px 20px',
                                fontSize: '14px',
                                fontWeight: '500'
                            }}
                        >
                            <i className="fa fa-arrow-left" style={{ marginRight: '8px' }}></i>
                            {backButtonText}
                        </button>
                    )}
                </div>
                
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        background: 'none',
                        border: 'none',
                        fontSize: '20px',
                        color: '#6c757d',
                        cursor: 'pointer',
                        padding: '5px',
                        lineHeight: '1'
                    }}
                    title="Close"
                >
                    ×
                </button>
            </div>
            
            <style jsx>{`
                @keyframes modalFadeIn {
                    from {
                        opacity: 0;
                        transform: scale(0.9) translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1) translateY(0);
                    }
                }
            `}</style>
        </div>
    );
};

export default ErrorModal;
